import { createRoot } from "react-dom/client";
import React, { lazy } from "react";
import { createClient, getScopes, msalGetOrCreate } from "../api";
import { AppProps } from "../AppProps";
import { AuthenticationResult, EventMessage, EventType } from "@azure/msal-browser";
import { ApolloProvider } from "@apollo/client";

const WebApiView = lazy(() => import('./WebApiView'));

export async function renderWebApi(e: Element, props: AppProps & {location: string}) {
  const domNode = createRoot(e);

  const msalInstance = await msalGetOrCreate(props.b2cEndpoint, props.b2cDomainName, props.b2cClientId, props.endSessionEndpoint);

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
      if (payload.state)
        document.location = payload.state;
    }
  });

  await msalInstance.handleRedirectPromise();

  if (msalInstance.getActiveAccount() == null) {
    const returnUrl = document.location.pathname + document.location.search + document.location.hash;

    let scopes = getScopes(props.b2cDomainName);
    await msalInstance.loginRedirect({
      scopes,
      state: returnUrl,
      redirectUri: props.baseUrl + "/webapi"
    });
  }
  else {

    const client = createClient(props.baseUrl, msalInstance, props.b2cDomainName, props.persistedQueries);

    domNode.render(
      <React.StrictMode>
        <ApolloProvider client={client}>
          <WebApiView b2cDomainName={props.b2cDomainName} msalClient={msalInstance} location={ props.location} />
        </ApolloProvider>
      </React.StrictMode>
    );
  }
}